import FeatureStore from "@rock-solid/feature-store";

import FeatureFlag, { FeatureFlagUsa } from "@repo/kikoff-models/FeatureFlag";
import usRpc from "@repo/protobuf/api/usRpc";

const initialState = {
  byName: {} as { [Name in FeatureFlag.Name]?: boolean },
};

export const { useFeatureFlags } = FeatureStore.init(
  "FeatureFlags",
  initialState
).setup(([store, setStore], { attachAction, wrap }) => {
  const accessors = wrap
    .accessors({
      enabled: attachAction(
        (name: FeatureFlag.Name) => store.byName[name],
        (name) => actions.fetch(name),
        () => (res) => res !== undefined
      ),
    })
    .finalize();

  const actions = wrap
    .actions({
      // Endpoint doesn't support specifying names, we will keep the interface as if it does.
      // eslint-disable-next-line no-unused-vars
      fetch(...names: FeatureFlag.Name[]) {
        return usRpc.Account.getSiteVars({}).then(({ featureFlags }) => {
          setStore(
            "byName",
            Object.fromEntries(
              featureFlags.map(({ name, pass }) => [
                FeatureFlagUsa.Name.normalize(name),
                pass,
              ])
            )
          );
        });
      },
    })
    .finalize();

  return { accessors, actions };
});
